import { Navigate, useLocation } from "react-router-dom";
import React from "react";
const ProtectedRoute = ({ children, isAllowed }) => {
  const location = useLocation();
  const userRole = localStorage.getItem("userRole");

  if (!isAllowed) {
    return (
      <Navigate
        to={`/auth/login?redirect=${encodeURIComponent(
          location.pathname + location.search
        )}`}
        replace
      />
    );
    // return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }
  return children;
};

export default ProtectedRoute;
